<template>
	<transition
		name="router-anim"
		mode="out-in"
		:enter-active-class="transitionEnterActiveClass"
		:leave-active-class="transitionLeaveActiveClass"
	>
    <slot/>
  </transition>
</template>


<script>
export default {
	data() {
    return {
			transitionEnterActiveClass: null,
			transitionLeaveActiveClass: null
    };
  },
  created() {
    this.$router.beforeEach((to, from, next) => {

      if (to.meta.transitionName === `slide-left`) {
        this.transitionEnterActiveClass = 'animated fadeInRight'
				this.transitionLeaveActiveClass = 'animated fadeOutLeft'
      }
      if (from.meta.transitionName === `slide-left`) {
        this.transitionEnterActiveClass = 'animated fadeInLeft'
				this.transitionLeaveActiveClass = 'animated fadeOutRight'
      }

      next();
    });
  }
}
</script>

<style lang="stylus" scoped>
  // @import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css"

	.animated
		animation-duration .25s
		animation-fill-mode both

	@keyframes fadeOutLeft
		from
			opacity 1

		to
			opacity 0
			transform translate3d(-100%, 0, 0)

	@keyframes fadeOutRight
		from
			opacity: 1

		to
			opacity 0
			transform translate3d(100%, 0, 0)

	@keyframes fadeInLeft
		from
			opacity 0
			transform translate3d(-100%, 0, 0)

		to
			opacity 1
			transform translate3d(0, 0, 0)
	
	@keyframes fadeInRight
		from
			opacity 0
			transform translate3d(100%, 0, 0)

		to
			opacity 1
			transform translate3d(0, 0, 0)

	.fadeOutLeft
		animation-name fadeOutLeft

	.fadeOutRight
		animation-name fadeOutRight

	.fadeInLeft 
		animation-name fadeInLeft

	.fadeInRight
		animation-name fadeInRight

  // .slide-left-enter-active,
  // .slide-left-leave-active,
  // .slide-right-enter-active,
  // .slide-right-leave-active
  //   transition all .5s ease
  //   overflow: hidden

  // .slide-left-enter,
  // .slide-right-leave-active
  //   opacity: 0
  //   transform: translate(50%, 0)

  // .slide-left-leave-active,
  // .slide-right-enter
  //   opacity: 0
  //   transform: translate(-50%, 0)
</style>
